import screenfull from 'screenfull'
import * as Sentry from '@sentry/vue'
import Config from '@/config'
import {
  SET_CURRENT_SLIDE_MODE,
  FULL_SCREEN_MODE,
  WINDOWED_MODE,
} from '@/vuex/types'
import Utils from '@/util'
import Constants from '@/constant'
import Socket from '@/socket'
import SlideApi from '@/api/slide'
import store from '@/vuex/store'

export default {
  getPresentationDetailURL(sharePresentation) {
    // get different data to display on Editor vs sharePresentation screen
    let url = Config.api.getPresentationDetail
    if (sharePresentation) {
      url = Config.api.sharePresentation
    }
    return url
  },

  checkToSetFullScreenMode(isPresentationOwnerAndPresenting,
    isRememberedFullscreenNotDemoMode, editor) {
    if (!isPresentationOwnerAndPresenting) return
    if (sessionStorage.getItem('zoomApp') == 'true') return
    if (isRememberedFullscreenNotDemoMode) {
      try {
        screenfull.request().catch(() => {})
        editor.$store.dispatch(SET_CURRENT_SLIDE_MODE, FULL_SCREEN_MODE)
      } catch (e) {
        Sentry.captureException(e)
        editor.$store.dispatch(SET_CURRENT_SLIDE_MODE, WINDOWED_MODE)
      }
    } else {
      editor.$store.dispatch(SET_CURRENT_SLIDE_MODE, WINDOWED_MODE)
    }

    if (editor.isDesktopPresenting) {
      editor.$router.replace({
        name: 'PresentationDetail',
        params: { id: editor.presentation.id },
        query: { presenting: true },
      })
    }
  },

  async updateSlideToQuizLobbyScreen(editor) {
    if (editor.sharePresentation || store.state.currentUser.accountRole === 'viewer') {
      return
    }
    const payload = {
      quizStatus: Constants.QuizStatuses.LOBBY_SCREEN,
      socketId: Socket.getSocketId(),
      accessCode: editor.presentation.uniqueAccessCode,
      presentationId: editor.presentation.id,
      presenting: editor.isPresenting || editor.isBackstage,
    }
    try {
      await SlideApi.updateSlideById(editor.slideActive.id, payload)
    } catch (error) {
      Sentry.captureException(error)
    }
    const indexSlide = Utils.getIndexSlide(
      editor.presentation.slides,
      editor.slideActive.id,
    )
    if (payload.quizStatus) {
      editor.$store.state.presentation.slides[indexSlide].quizStatus =
          payload.quizStatus
    }
  },

  checkShowQuizCorrectAnswerIconReminder(editor) {
    const { slides } = editor.$store.state.presentation
    this._setSlideIconReminder('has check', slides)
    const exceptSlideTypes = ['matchPairs', 'correctOrder', 'categorise']

    const allQuizSlides = slides.filter((slide) => slide.type === 'pickAnswer'
      && !exceptSlideTypes.includes(slide.slideType))

    const allSlidesNeedReminder = this._getAllSlidesNeedReminder(allQuizSlides, editor)
    editor.$store.state.presentation.quizNoCorrectAnswer = allSlidesNeedReminder

    this._setSlideIconReminder('some not checked', allSlidesNeedReminder)
  },

  _setSlideIconReminder(type, allSlides) {
    if (!allSlides) return
    allSlides.forEach((slide) => {
      if (type == 'has check') {
        slide.notCheckCorrectAnswer = false
      } else if (type == 'some not checked') {
        slide.notCheckCorrectAnswer = true
      }
    })
  },

  _getAllSlidesNeedReminder(allQuizSlides, editor) {
    return allQuizSlides.filter((slide) => {
      if (slide.slideType === 'typeAnswer') {
        this._updateSlideCorrectTypeAnswer(slide, editor)
        if ((slide.correctQuizTypeAnswer && slide.correctQuizTypeAnswer.replace(/\s/g, '') !== '') || (slide.otherCorrectQuiz && slide.otherCorrectQuiz.length && slide.otherCorrectQuiz.some((option) => option.title && option.title.replace(/\s/g, '') !== ''))) {
          return false
        }
        return true
      }

      if (slide.SlideOptions && slide.SlideOptions.every((slideOption) => !slideOption.correct)) {
        return true
      }

      return false
    })
  },

  _updateSlideCorrectTypeAnswer(slide, editor) {
    const { slideActive } = editor.$store.state
    if (slide.id == slideActive.id) {
      slide.correctQuizTypeAnswer = slideActive.correctQuizTypeAnswer
      slide.otherCorrectQuiz = slideActive.otherCorrectQuiz
    }
  },

  handleGetDataPresentationDetailFailed(err, editor, presentationId) {
    editor.$router.push('/apps/presentations')
    const messageErrorNoPermission = "Your don't have permission to edit this presentation"
    if (err && err.status === 400 && err.body.message === messageErrorNoPermission && store.getters['featureToggles/canUseRequestAccessPresentation']) {
      store.dispatch('presentationsModule/setPresentationNoPermission', presentationId)
      return
    }
    Utils.mixpanelTracking(Constants.eventCategories.PRESENTATION_LIST, 'Presentation > Open > Failed')
    const matchPresentation =
        editor.presentations.find((item) => presentationId === item.id)
    if (matchPresentation) {
      editor.setErrorOnInternalServerAction(`Cannot open presentation ${`: ${matchPresentation.name}` || ''}`)
    } else {
      editor.setErrorOnInternalServerAction('Presentation not found!')
    }
  },
}
